export default "__VITE_ASSET___cbvQewk__"